import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import Listing from './Listing';
import { currencyCodeAndSymbolPropTypes } from '../../../util/currency';

const propTypes = exact({
  currentCurrency: currencyCodeAndSymbolPropTypes,
  fromPriceText: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  limitedAvailabilityText: PropTypes.string.isRequired,
  perPersonText: PropTypes.string,
  noResultsMessage: PropTypes.string.isRequired,
  soldOutText: PropTypes.string.isRequired,
  useGridLayout: PropTypes.bool,
  viewTourText: PropTypes.string,
  waitingListText: PropTypes.string,
});

const defaultProps = {
  fromPriceText: 'from',
  perPersonText: 'pp',
  useGridLayout: false,
  viewTourText: 'view package',
  waitingListText: null,
};

function Results(props) {
  const items = props.items.map((item) => {
    const { itinerary, type, options, ...rest } = item;
    return rest;
  });

  return (
    <div className={`PackageResults${props.useGridLayout ? ' PackageResults-grid' : ''}`}>
      {items.map((item) => (
        <div key={item.key} className="PackageResults_listing">
          <Listing
            {...item}
            tourKey={item.key}
            fromPriceText={props.fromPriceText}
            limitedAvailabilityText={props.limitedAvailabilityText}
            limitedAvailabilityTextOverride={item.limitedAvailabilityText}
            soldOutText={props.soldOutText}
            viewTourText={props.viewTourText}
            waitingListText={props.waitingListText}
            useGridLayout={props.useGridLayout}
            currentCurrency={props.currentCurrency}
            perPersonText={props.perPersonText}
          />
        </div>
      ))}
      {items.length < 1 && <div className="PackageResults_noResults">{props.noResultsMessage}</div>}
    </div>
  );
}

Results.propTypes = propTypes;
Results.defaultProps = defaultProps;

export default Results;
